const eventsLists = [
	{
		title: "Technical Events",
		events: ["technovation", "Coding", "Web page", "Debugging", "CrackAlgos", "&nbsp;"],
	},
	{
		title: "Non-Technical Events",
		events: ["Poster", "Presentation", "Kala Se Kalakar", "Quizeria", "Just a minute", "Stand-up Comedy"],
	},
	{
		title: "Gaming Events",
		events: ["Counter-Strike: Global Offensive ", "Valorant", "&nbsp;", "&nbsp;", "&nbsp;", "&nbsp;"],
	},
];
export default eventsLists;
